import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  Input,
} from "reactstrap";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import reloadIcon from "assets/icon/reload-icon.svg";
import refreshIcon from "../../../../../assets/icon/refresh-purple.svg";

import { Navigate, useNavigate } from "react-router-dom";
import DrugName from "components/DrugName";

const OrdersPage = () => {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [rSelected, setRSelected] = useState("off");
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [data, setData] = useState([]);

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  const handleRowClick = (row, e) => {
    if (e.target.value !== "checkbox") {
      navigate(`/inventory-purchase-order/order-history/${row.id}`, {
        state: row,
      });
    }
  };
  const rowData = [
    {
      id: 11111,
      // all: <Checkbox />,
      status: "Partial",

      drugname: "Amlodopine 10 MG",
      orderdate: "2/15/2025",
      ndc: "65162017550",
      expecteddate: "2/10/2025",
      wholesaler: "Mckesson",
      ponumber: "P0-24015001",
      orderQty: "5",
    },
    {
      id: 2211111,
      // all: <Checkbox />,
      status: "Partial",
      drugname: "Amoxicillin 400MG/5ML Susp",
      orderdate: "1/20/2025",
      ndc: "00093724073",
      expecteddate: "2/8/2025",
      wholesaler: "Cardinal",
      ponumber: "P0-24020002",
      orderQty: "12",
    },
    {
      id: 33111,
      // all: <Checkbox />,
      status: "Ready to Receive",
      drugname: "Sertraline 100MG Tablet",
      orderdate: "1/22/2025",
      ndc: "57237012430",
      expecteddate: "2/6/2025",
      wholesaler: "Mckesson",
      ponumber: "P0-24022003",
      orderQty: "3",
    },
    {
      id: 5511,
      // all: <Checkbox />,
      status: "Partial",

      drugname: "Adderall XR 20MG Capsule",
      orderdate: "1/25/2025",
      ndc: "57237012430",
      expecteddate: "2/15/2025",
      wholesaler: "BluPax",
      ponumber: "P0-24025004",
      orderQty: "2",
    },
    {
      id: 66222,
      // all: <Checkbox />,
      status: "On Order",
      drugname: "Ozempic 1MG/0.75ML Pen",
      orderdate: "1/26/2025",
      ndc: "57237012401",
      expecteddate: "2/12/2025",
      wholesaler: "Cardinal",
      ponumber: "P0-24026005",
      orderQty: "3",
    },
    {
      id: 7743,
      // all: <Checkbox />,
      status: "To Be Ordered",
      drugname: "Eliquis 5 MG Tablet",
      orderdate: "1/27/2025",
      ndc: "57237012401",
      expecteddate: "N/A",
      wholesaler: "Mckesson",
      ponumber: "P0-24027006",
      orderQty: "6",
    },
    {
      id: 554,
      // all: <Checkbox />,
      status: "Partial",

      drugname: "Adderall XR 20MG Capsule",
      orderdate: "1/25/2025",
      ndc: "57237012430",
      expecteddate: "2/15/2025",
      wholesaler: "BluPax",
      ponumber: "P0-24025004",
      orderQty: "2",
    },
    {
      id: 6600,
      // all: <Checkbox />,
      status: "On Order",
      drugname: "Ozempic 1MG/0.75ML Pen",
      orderdate: "1/26/2025",
      ndc: "57237012401",
      expecteddate: "2/12/2025",
      wholesaler: "Cardinal",
      ponumber: "P0-24026005",
      orderQty: "3",
    },
    {
      id: 7781,
      // all: <Checkbox />,
      status: "To Be Ordered",
      drugname: "Eliquis 5 MG Tablet",
      orderdate: "1/27/2025",
      ndc: "57237012401",
      expecteddate: "N/A",
      wholesaler: "Mckesson",
      ponumber: "P0-24027006",
      orderQty: "6",
    },
    {
      id: 7672,
      // all: <Checkbox />,
      status: "Cancelled",
      drugname: "Entresto 97/103MG Tablet",
      orderdate: "1/28/2025",
      ndc: "57237012421",
      expecteddate: "N/A",
      wholesaler: "Anda",
      ponumber: "P0-24028007",
      orderQty: "2",
    },
    {
      id: 7373,
      // all: <Checkbox />,
      status: "Partial",
      drugname: "Januvia 100MG Tablet",
      orderdate: "1/28/2025",
      ndc: "57237012420",
      expecteddate: "2/14/2025",
      wholesaler: "Mckesson",
      ponumber: "P0-24028008",
      orderQty: "4",
    },
    {
      id: 1774,
      // all: <Checkbox />,
      status: "To Be Ordered",
      drugname: "Lantus 100U/ML Pen",
      orderdate: "1/28/2025",
      ndc: "57237012431",
      expecteddate: "2/11/2025",
      wholesaler: "Cardinal",
      ponumber: "P0-24029009",
      orderQty: "5",
    },
    {
      id: 7275,
      // all: <Checkbox />,
      status: "To Be Ordered",
      drugname: "Shingrix Vaccine",
      orderdate: "1/28/2025",
      ndc: "57237012412",
      expecteddate: "2/7/2025",
      wholesaler: "Mckesson",
      ponumber: "P0-24030010",
      orderQty: "2",
    },
  ];
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(rowData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };
  const herderData = [
    {
      dataField: "check",
      // width:120,
      text: (
        <div className="d-flex justify-content-flexstart align-items-baseline gap-1 mb-1">
          <Input
            type="checkbox"
            onChange={handleSelectAll}
            checked={selectedRows.length === rowData.length}
          />
          All
        </div>
      ),
      cellRenderer: (rowData) => (
        <Input
          type="checkbox"
          onChange={() => handleSelectRow(rowData.id)}
          checked={selectedRows.includes(rowData.id)}
        />
      ),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      inputType: "checkbox",
    },
    {
      dataField: "status",
      text: "Status",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 160,
      cellRenderer: (rowData) => DrugName(rowData),
    },
    {
      dataField: "orderdate",
      text: "Order Date",
      show: true,
      sort: true,
      width: 110,
    },
    {
      dataField: "ndc",
      text: "NDC",
      show: true,
      sort: true,
    },
    {
      dataField: "expecteddate",
      text: "Expected Date",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "wholesaler",
      text: "Wholesaler",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "ponumber",
      text: "Po Number",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "orderQty",
      text: "Order QTY",
      show: true,
      sort: true,
      width: 100,
    },
  ];
  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 1000);
  };

  return (
    <div className="table-card scroll-table position-relative border-0 pt-1 rounded bg-white">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {refreshBtn && (
          <div className="refresh-bgv">
            <img className="rotate-img" src={refreshIcon} width={40} />
          </div>
        )}
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={data}
              setFilterData={setTableData}
            />
          </div>
          <div>
            <Dropdown isOpen={undefined} toggle={undefined}>
              <DropdownToggle className="clmn">
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div>
          <Button color="primary" onClick={handleRefresh}>
            <img src={reloadIcon} alt="Refreshing..." />
            Refresh
          </Button>{" "}
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="purchase-orderhistory"
          data={rowData}
          columns={herderData}
          enablerowRouting={true}
          handleRowClick={handleRowClick}
        />
      </div>
    </div>
  );
};

export default OrdersPage;
